type State = {
    checked: boolean;
    indeterminate: boolean;
};

export const getCheckboxState = ({ checked, indeterminate }: State) => {
    if (!checked && indeterminate) {
        return { checked: true, indeterminate: false };
    }
    if (checked && !indeterminate) {
        return { checked: false, indeterminate: false };
    }
    return { checked: false, indeterminate: true };
};
